import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const Wrapper = styled.div<{ isPromoCard?: boolean }>`
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.15);
  background: ${(props) => props.theme.color.light.default};
  border-radius: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  ${(props) => props.isPromoCard && 'cursor: pointer;'}
`;

export const Header = styled.div<{ active: boolean; isPromoCard?: boolean }>`
  border-radius: 10px 10px 0 0;
  padding: 10px 20px;
  background: ${(props) =>
    props.active ? props.theme.color.blue.default : props.theme.color.medium.default};
  color: ${(props) => props.theme.color.light.default};
  display: flex;
  flex-direction: column;
  ${(props) => props.isPromoCard && 'height: 86px; justify-content: center;'}
`;

export const Title = styled.div<{ isPromoCard?: boolean }>`
  font-weight: 600;
  font-size: 16px;
  ${(props) => props.isPromoCard && 'text-align: center;'}
`;

export const TimecountWrapper = styled.div`
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  white-space: nowrap;
`;

export const Timecount = styled.div`
  margin-left: 5px;
`;

export const Section = styled.div<{ isGrey?: boolean }>`
  display: flex;
  align-items: center;
  ${mediaQuery('tablet')} {
    flex-direction: column;
    /* text-align: center; */
  }
  padding: 10px 20px;
  border-bottom: 1px solid ${(props) => props.theme.color.light.shade};
  ${(props) => props.isGrey && `background: ${props.theme.color.light.shadeLighter};`}
`;

export const SectionContent = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-weight: 600;
  font-size: 16px;
`;

export const Text = styled.p`
  margin: 0;
  font-weight: 400;
  font-size: 16px;
`;

export const WarningText = styled.p`
  margin: 0;
  color: ${(props) => props.theme.color.red.default};
  font-size: 14px;
  font-weight: 600;
`;

export const Image = styled.img`
  object-fit: cover;
  width: 64px;
  height: 64px;
  border-radius: 100%;
  margin-right: 25px;
  ${mediaQuery('tablet')} {
    margin-top: 10px;
  }
`;

export const PromoImage = styled.img`
  height: 231px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700px;
  padding: 10px 60px;
  background: ${(props) => props.theme.color.light.shadeLighter};
  border-radius: 0 0 10px 10px;

  & > *:not(:last-child) {
    margin-right: 30px;
  }

  ${mediaQuery('tablet')} {
    padding: 10px 30px;
  }
`;

export const Button = styled.div<{ color: 'blue' | 'yellow' | 'red' }>`
  font-weight: 700;
  cursor: pointer;
  color: ${(props) => props.theme.color[props.color].default};
`;

export const Container = styled.div`
  margin-top: 5px;
`;

export const Label = styled.div`
  font-weight: 500;
  flex-shrink: 1;
  font-size: 14px;
`;

export const Value = styled.div`
  margin-left: auto;
`;
